import { useState } from "react";

import { robotColor, type RobotBranding } from "../model/types";

/**
 * Аватар робота. Заменяет цветной кружок везде, где он крупнее декоративной
 * точки: витрина, строка каталога, подтверждение покупки, «Мои роботы».
 *
 * Картинки может не быть — это нормальное состояние, а не ошибка: до первой
 * загрузки из админки робот выглядит ровно как раньше, цветным кружком в своём
 * акценте. Тот же кружок показывается, если картинка не загрузилась: битый
 * бакет не должен оставлять дырку в карточке.
 *
 * `alt` пустой намеренно: имя робота всегда стоит рядом текстом, и озвучивать
 * его дважды — шум для скринридера.
 */
const SIZES = {
  28: "size-7",
  34: "size-[34px]",
  36: "size-9",
} as const;

export type RobotAvatarSize = keyof typeof SIZES;

export function RobotAvatar({
  robot,
  size,
  className = "",
}: {
  robot: RobotBranding;
  size: RobotAvatarSize;
  className?: string;
}) {
  const [broken, setBroken] = useState(false);
  // Классы перечислены статически: Tailwind вырезает имена, собранные на лету,
  // и `size-[${n}px]` молча не попал бы в сборку (та же причина, что у
  // `--color-bot-*` в tokens.css).
  const box = `${SIZES[size]} shrink-0 rounded-full ${className}`;

  if (robot.image_url && !broken) {
    return (
      <img
        src={robot.image_url}
        alt=""
        loading="lazy"
        decoding="async"
        onError={() => {
          setBroken(true);
        }}
        className={`${box} object-cover`}
      />
    );
  }

  return <span className={box} style={{ backgroundColor: robotColor(robot) }} aria-hidden="true" />;
}
